import { Link } from "react-router-dom"

export default function NotFound() {
  return (
    <div>
        <h2>NotFound</h2>
        <p> Voltar para a <Link to="/">Home</Link></p>
    </div>
  )
}
